document.addEventListener('DOMContentLoaded', function() {
  // Delay execution slightly to ensure all DOM elements are fully loaded
  setTimeout(initMomSaysSection, 500);
  
  function initMomSaysSection() {
    const sectionContainer = document.getElementById('mom-says-section');
    const productsContainer = document.getElementById('mom-says-products');
    const loadingElement = document.getElementById('mom-says-loading');
    
    if (!sectionContainer || !productsContainer || !loadingElement) return;
    
    // Get cookie function
    function getCookie(name) {
      const nameEQ = name + "=";
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i].trim();
        if (c.indexOf(nameEQ) === 0) {
          return c.substring(nameEQ.length, c.length);
        }
      }
      return null;
    }
    
    // Get customer group from cookie
    const customerGroup = getCookie("mom_customer_group");
    if (!customerGroup) {
      // Don't show the section if no customer group cookie is present
      return;
    }
    
    // Show the section container but keep loading state visible
    sectionContainer.style.display = 'block';
    
    // Get current product handle to exclude from recommendations
    const currentPath = window.location.pathname;
    const currentHandle = currentPath.match(/\/products\/([^\/]+)/)?.[1] || '';
    
    // Step 1: Fetch the segmented scores
    fetch('https://cdn.shopify.com/s/files/1/0567/4870/3914/files/customer-segment-ai-response.json?v=1743848596')
      .then(response => response.json())
      .then(segmentData => {
        // Process the segmented data
        let segmentProducts = [];
        if (Array.isArray(segmentData)) {
          segmentProducts = segmentData;
        } else if (segmentData.products && Array.isArray(segmentData.products)) {
          segmentProducts = segmentData.products;
        }
        
        // Filter products with scores 90+ for this customer's group
        const highScoredProducts = segmentProducts.filter(product => {
          const handle = product.Handle || product.handle;
          const segmentScores = product.segment_scores || product;
          
          // Skip the current product
          if (handle === currentHandle) return false;
          
          // Check for high score
          return segmentScores && 
                 segmentScores[customerGroup] !== undefined && 
                 segmentScores[customerGroup] >= 90;
        });
        
        if (highScoredProducts.length === 0) {
          // No high-scoring products found, don't show the section
          sectionContainer.style.display = 'none';
          return;
        }
        
        // Shuffle all products to prepare a larger pool
        const shuffledProducts = shuffleArray(highScoredProducts);
        
        // Try to get 6 products initially (double what we need) to have fallbacks
        const initialProductSet = shuffledProducts.slice(0, 6);
        
        // Now fetch product details for these handles
        const productHandles = initialProductSet.map(p => p.Handle || p.handle);
        
        // Create a map of handles to scores
        const scoreMap = {};
        initialProductSet.forEach(product => {
          const handle = product.Handle || product.handle;
          const segmentScores = product.segment_scores || product;
          if (segmentScores && segmentScores[customerGroup] !== undefined) {
            scoreMap[handle] = segmentScores[customerGroup];
          }
        });
        
        // Use Promise.allSettled instead of Promise.all to handle individual rejections
        Promise.allSettled(productHandles.map(handle => 
          fetch(`/products/${handle}.js`)
            .then(res => {
              if (!res.ok) {
                throw new Error(`Failed to fetch product ${handle}: ${res.status} ${res.statusText}`);
              }
              return res.json();
            })
            .catch(error => {
              console.warn(`Error with product ${handle}:`, error.message);
              return null; // Return null for failed products
            })
        ))
          .then(results => {
            // Extract successful product data
            const productDetails = results
              .filter(result => result.status === 'fulfilled' && result.value !== null)
              .map(result => result.value);
            
            // If we don't have enough valid products, don't show the section
            if (productDetails.length < 1) {
              console.error('No valid products found');
              sectionContainer.style.display = 'none';
              return;
            }
            
            // Take only the first 3 valid products
            const validProducts = productDetails.slice(0, 3);
            
            // Hide loading indicator
            loadingElement.style.display = 'none';
            
            // Show products container
            productsContainer.style.display = 'grid';
            
            // Render the valid products
            renderSuggestedProducts(validProducts, scoreMap);
          })
          .catch(error => {
            console.error('Error processing products:', error);
            sectionContainer.style.display = 'none';
          });
      })
      .catch(error => {
        console.error('Error fetching segment data:', error);
        sectionContainer.style.display = 'none';
      });
  }
  
  // Function to render suggested products
  function renderSuggestedProducts(products, scoreMap) {
    const container = document.getElementById('mom-says-products');
    if (!container) return;
    
    let html = '';
    
    products.forEach(product => {
      if (!product || !product.handle) {
        console.warn('Invalid product data:', product);
        return; // Skip this iteration
      }
      
      try {
        const handle = product.handle;
        const title = product.title || 'Product';
        const price = formatMoney(product.price || 0);
        const comparePrice = product.compare_at_price ? formatMoney(product.compare_at_price) : null;
        const variantId = product.variants && product.variants.length > 0 ? product.variants[0].id : null;
        
        // Get product images for hover effect
        const images = product.images || [];
        const mainImage = images.length > 0 ? images[0] : '';
        // Use 2nd image (index 1) for hover if available, otherwise use main image
        const hoverImage = images.length > 1 ? images[1] : mainImage;
        
        html += `
          <div class="mom-product-card" data-product-id="${product.id}" data-variant-id="${variantId}">
            <div class="mom-product-img">
              <a href="/products/${handle}" aria-label="View ${title}">
                <img 
                  src="${mainImage}" 
                  alt="${title}" 
                  loading="lazy"
                  class="main-image"
                  onerror="this.onerror=null; this.src='//cdn.shopify.com/s/files/1/0533/2089/files/placeholder-image.png?v=1530129081'"
                >
                <img 
                  src="${hoverImage}" 
                  alt="${title}" 
                  loading="lazy"
                  class="hover-image"
                  onerror="this.onerror=null; this.src='//cdn.shopify.com/s/files/1/0533/2089/files/placeholder-image.png?v=1530129081'"
                >
              </a>
            </div>
            <div class="mom-product-content">
              <h3 class="mom-product-title">
                <a href="/products/${handle}">${title}</a>
              </h3>
              <div class="mom-product-price">
                ${comparePrice ? 
                  `<span>${price}</span>
                   <span class="compare-at-price">${comparePrice}</span>` : 
                  `<span>${price}</span>`
                }
                ${variantId ? 
                  `<button class="mom-add-btn" aria-label="Add to cart" data-variant-id="${variantId}" onclick="momAddToCart(${variantId}, event)">    <svg width="21" height="17" viewBox="0 0 21 17" fill="green" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.3699 15.3407C14.1509 15.3407 13.941 15.2535 13.7862 15.0982C13.6314 14.943 13.5444 14.7324 13.5444 14.5128H11.8936C11.8936 15.1715 12.1545 15.8032 12.6189 16.269C13.0832 16.7347 13.7131 16.9964 14.3699 16.9964C15.0266 16.9964 15.6565 16.7347 16.1209 16.269C16.5853 15.8032 16.8462 15.1715 16.8462 14.5128H15.1953C15.1953 14.7324 15.1083 14.943 14.9535 15.0982C14.7987 15.2535 14.5888 15.3407 14.3699 15.3407Z"></path>
              <path d="M8.5612 15.3407C8.34228 15.3407 8.13233 15.2535 7.97753 15.0982C7.82273 14.943 7.73576 14.7324 7.73576 14.5128H6.07715C6.07715 14.8395 6.14129 15.1629 6.26592 15.4646C6.39055 15.7664 6.57322 16.0406 6.8035 16.2715C7.03378 16.5025 7.30717 16.6857 7.60805 16.8107C7.90893 16.9357 8.23141 17 8.55707 17C8.88274 17 9.20522 16.9357 9.5061 16.8107C9.80698 16.6857 10.0804 16.5025 10.3106 16.2715C10.5409 16.0406 10.7236 15.7664 10.8482 15.4646C10.9729 15.1629 11.037 14.8395 11.037 14.5128H9.38612C9.38612 14.7323 9.29923 14.9428 9.14454 15.098C8.98985 15.2533 8.78003 15.3406 8.5612 15.3407Z"></path>
              <path d="M19.3299 1.64401C19.2849 1.63633 19.2393 1.63252 19.1937 1.63263H5.9867C5.76778 1.63263 5.55782 1.71985 5.40302 1.8751C5.24823 2.03035 5.16126 2.24092 5.16126 2.46047C5.16126 2.68003 5.24823 2.8906 5.40302 3.04585C5.55782 3.2011 5.76778 3.28832 5.9867 3.28832H18.2192L18.001 4.60149L16.8438 11.5668H6.07595L3.26946 4.60149L1.59537 0.482961C1.50684 0.289212 1.34721 0.13717 1.14972 0.0584856C0.952225 -0.020199 0.732083 -0.0194636 0.535118 0.0605389C0.338153 0.140541 0.179541 0.293646 0.0922992 0.487983C0.00505767 0.682319 -0.00409102 0.902913 0.0667575 1.10384L2.73963 7.68158L4.56385 12.5307C4.6985 12.9389 4.97657 13.2224 5.37794 13.2224H17.5428C17.7383 13.2225 17.9275 13.1531 18.0766 13.0264C18.2258 12.8997 18.3253 12.724 18.3574 12.5307L19.675 4.60149L20.0083 2.59655C20.0443 2.38002 19.993 2.15803 19.8658 1.9794C19.7386 1.80077 19.5458 1.68013 19.3299 1.64401Z"></path>
            </svg></button>` : 
                  ``
                }
              </div>
            </div>
          </div>
        `;
      } catch (error) {
        console.error('Error rendering product:', error);
      }
    });
    
    // If no products were rendered successfully, hide the section
    if (html === '') {
      const sectionContainer = document.getElementById('mom-says-section');
      if (sectionContainer) sectionContainer.style.display = 'none';
      return;
    }
    
    container.innerHTML = html;
  }
  
    
    // Add global function for add to cart
    if (typeof window.momAddToCart !== 'function') {
      window.momAddToCart = function(variantId, event) {
        console.log('Mom add to cart clicked:', variantId);
        event.preventDefault();
        event.stopPropagation();
        
        if (!variantId) {
          console.error('No variant ID provided for add to cart');
          return;
        }
        
        const button = event.currentTarget;
        const originalHTML = button.innerHTML;
        
        // Show loading state
        button.innerHTML = `<div class="mom-loading-spinner" style="width:10px;height:10px;border-width:2px;margin:0 auto;"></div>`;
        button.disabled = true;
        
        console.log('Adding to cart:', variantId);
        
        // Add to cart using fetch API
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [{
              id: variantId,
              quantity: 1
            }]
          })
        })
        .then(response => {
          console.log('Cart response status:', response.status);
          if (!response.ok) {
            throw new Error(`Server responded with ${response.status}: ${response.statusText}`);
          }
          return response.json();
        })
        .then(data => {
          console.log('Cart response data:', data);
          
          if (data.status && data.status !== 200) {
            throw new Error(data.description || 'Error adding product to cart');
          }
          
          // Success - show icon only
          button.innerHTML = `
            <svg width="21" height="17" viewBox="0 0 21 17" fill="green" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.3699 15.3407C14.1509 15.3407 13.941 15.2535 13.7862 15.0982C13.6314 14.943 13.5444 14.7324 13.5444 14.5128H11.8936C11.8936 15.1715 12.1545 15.8032 12.6189 16.269C13.0832 16.7347 13.7131 16.9964 14.3699 16.9964C15.0266 16.9964 15.6565 16.7347 16.1209 16.269C16.5853 15.8032 16.8462 15.1715 16.8462 14.5128H15.1953C15.1953 14.7324 15.1083 14.943 14.9535 15.0982C14.7987 15.2535 14.5888 15.3407 14.3699 15.3407Z"></path>
              <path d="M8.5612 15.3407C8.34228 15.3407 8.13233 15.2535 7.97753 15.0982C7.82273 14.943 7.73576 14.7324 7.73576 14.5128H6.07715C6.07715 14.8395 6.14129 15.1629 6.26592 15.4646C6.39055 15.7664 6.57322 16.0406 6.8035 16.2715C7.03378 16.5025 7.30717 16.6857 7.60805 16.8107C7.90893 16.9357 8.23141 17 8.55707 17C8.88274 17 9.20522 16.9357 9.5061 16.8107C9.80698 16.6857 10.0804 16.5025 10.3106 16.2715C10.5409 16.0406 10.7236 15.7664 10.8482 15.4646C10.9729 15.1629 11.037 14.8395 11.037 14.5128H9.38612C9.38612 14.7323 9.29923 14.9428 9.14454 15.098C8.98985 15.2533 8.78003 15.3406 8.5612 15.3407Z"></path>
              <path d="M19.3299 1.64401C19.2849 1.63633 19.2393 1.63252 19.1937 1.63263H5.9867C5.76778 1.63263 5.55782 1.71985 5.40302 1.8751C5.24823 2.03035 5.16126 2.24092 5.16126 2.46047C5.16126 2.68003 5.24823 2.8906 5.40302 3.04585C5.55782 3.2011 5.76778 3.28832 5.9867 3.28832H18.2192L18.001 4.60149L16.8438 11.5668H6.07595L3.26946 4.60149L1.59537 0.482961C1.50684 0.289212 1.34721 0.13717 1.14972 0.0584856C0.952225 -0.020199 0.732083 -0.0194636 0.535118 0.0605389C0.338153 0.140541 0.179541 0.293646 0.0922992 0.487983C0.00505767 0.682319 -0.00409102 0.902913 0.0667575 1.10384L2.73963 7.68158L4.56385 12.5307C4.6985 12.9389 4.97657 13.2224 5.37794 13.2224H17.5428C17.7383 13.2225 17.9275 13.1531 18.0766 13.0264C18.2258 12.8997 18.3253 12.724 18.3574 12.5307L19.675 4.60149L20.0083 2.59655C20.0443 2.38002 19.993 2.15803 19.8658 1.9794C19.7386 1.80077 19.5458 1.68013 19.3299 1.64401Z"></path>
            </svg>
          `;
          
          // Try to directly update cart count without refreshing page
          fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
              console.log('Cart updated:', cart.item_count, 'items');
              
              // Update all cart counters
              document.querySelectorAll(".cart-count").forEach(el => {
                if (el.classList.contains('cart-count-drawer')) {
                  el.innerHTML = `(${cart.item_count})`;
                } else {
                  el.innerHTML = cart.item_count;
                }
              });
              
              // Try to refresh cart if the function exists (theme specific)
              if (typeof refreshCart === 'function') {
                console.log('Using theme refreshCart function');
                refreshCart();
              } else if (typeof window.refreshCart === 'function') {
                console.log('Using window.refreshCart function');
                window.refreshCart();
              }
              
              // Try to update header price if that component exists
              if (document.querySelector("header-total-price")) {
                document.querySelector("header-total-price").updateTotal(cart);
              }
              
              // Try to update free shipping progress bar if it exists
              const cart_free_ship = document.querySelector("free-ship-progress-bar");
              if (cart_free_ship) {
                cart_free_ship.init(cart.items_subtotal_price);
              }
              
              // Try to open cart drawer if it exists
              const cartDrawer = document.querySelector("cart-drawer");
              if (cartDrawer && typeof cartDrawer.open === 'function') {
                setTimeout(() => {
                  cartDrawer.open();
                }, 100);
              }
              
              // Attempt to refresh mini cart if it exists
              const cartNotification = document.querySelector("cart-notification");
              if (cartNotification && typeof cartNotification.open === 'function') {
                setTimeout(() => {
                  cartNotification.open();
                }, 100);
              }
            })
            .catch(err => console.error('Error updating cart count:', err));
          
          // Reset button after 2 seconds
          setTimeout(() => {
            button.innerHTML = originalHTML;
            button.disabled = false;
          }, 2000);
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
          
          // Error - show error icon
          button.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="17" viewBox="0 0 24 24" fill="none" stroke="red" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="15" y1="9" x2="9" y2="15"></line>
              <line x1="9" y1="9" x2="15" y2="15"></line>
            </svg>
          `;
          
          // Reset button after 2 seconds
          setTimeout(() => {
            button.innerHTML = originalHTML;
            button.disabled = false;
          }, 2000);
        });
      };
    }
  
  // Helper function to format money
  function formatMoney(cents) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    
    const value = parseInt(cents, 10) || 0;
    const dollars = Math.floor(value / 100);
    const cents_part = (value % 100).toString().padStart(2, '0');
    return `$${dollars}.${cents_part}`;
  }
  
  // Shuffle array function (Fisher-Yates algorithm)
  function shuffleArray(array) {
    const newArray = [...array];
    for (let i = newArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
    }
    return newArray;
  }
});